import { render, staticRenderFns } from "./BlockCard.vue?vue&type=template&id=f6284776&scoped=true&"
import script from "./BlockCard.vue?vue&type=script&lang=js&"
export * from "./BlockCard.vue?vue&type=script&lang=js&"
import style0 from "./BlockCard.vue?vue&type=style&index=0&id=f6284776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6284776",
  null
  
)

export default component.exports